import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CustomComponent, Utils } from 'formiojs';

@Pipe({
	name: 'renderTemplate',
})
export class RenderTemplatePipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {}
	transform(
		template: string,
		data: Record<string, any>,
		formioComponent: CustomComponent
	): SafeHtml {
		try {
			const html = Utils.interpolate(template, {
				data: data,
				language: formioComponent.i18next.language,
				translate: formioComponent.t,
				instance: formioComponent,
				utils: Utils,
			});

			return this.sanitizer.bypassSecurityTrustHtml(html);
		} catch (error) {
			return null;
		}
	}
}
